module.exports = __webpack_public_path__ + "img/law_sample.964e025d.png";